module.exports = __webpack_public_path__ + "static/media/gtm-logo-black.7c7cc05b.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/img-loader!./src/assets/gtm-logo-black.png
// module id = 2211
// module chunks = 0